import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin, ArrowUpRight } from 'lucide-react';
import { CONTACT_INFO, INDUSTRIES } from '../mock';
import { SERVICE_PAGES, SERVICE_ORDER } from '../servicePages';

const Footer = () => {
  return (
    <footer className="relative bg-[#08080a] border-t border-white/5 mt-24">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <img src="/assets/yellow-logo.png" alt="Yellow" className="h-10 w-auto mb-4" />
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              Liverpool's strategic partner & creative consultancy. Strategy, video, design, digital. All under one roof, covering the entire UK.
            </p>
            <div className="flex gap-3 mt-6">
              <a href="https://www.facebook.com/yellowmarketingprogramme/?locale=en_GB" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center hover:border-[#F5CD1B] hover:text-[#F5CD1B] transition-colors">
                <Facebook size={15} />
              </a>
              <a href="https://www.instagram.com/yellowagencyinsta/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center hover:border-[#F5CD1B] hover:text-[#F5CD1B] transition-colors">
                <Instagram size={15} />
              </a>
              <a href="https://www.linkedin.com/company/theyellowagency" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center hover:border-[#F5CD1B] hover:text-[#F5CD1B] transition-colors">
                <Linkedin size={15} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="section-label mb-5">Industries</h4>
            <ul className="space-y-2.5">
              {INDUSTRIES.slice(0, 9).map((i) => (
                <li key={i}>
                  <span className="text-white/70 text-sm hover:text-[#F5CD1B] cursor-pointer transition-colors">{i}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="section-label mb-5">Services</h4>
            <ul className="space-y-2.5">
              {SERVICE_ORDER.map((slug) => (
                <li key={slug}>
                  <Link to={`/${slug}`} data-testid={`footer-service-${slug}`} className="text-white/70 text-sm hover:text-[#F5CD1B] transition-colors">{SERVICE_PAGES[slug].label}</Link>
                </li>
              ))}
              <li>
                <Link to="/free-marketing-health-check" data-testid="footer-free-health-check" className="text-[#F5CD1B] text-sm font-semibold hover:underline">Free Marketing Health Check</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="section-label mb-5">Get in touch</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-white/70 text-sm">
                <Phone size={16} className="text-[#F5CD1B] mt-0.5" />
                <span>{CONTACT_INFO.phone}</span>
              </li>
              <li className="flex items-start gap-3 text-white/70 text-sm">
                <Mail size={16} className="text-[#F5CD1B] mt-0.5" />
                <a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-[#F5CD1B]">{CONTACT_INFO.email}</a>
              </li>
              <li className="flex items-start gap-3 text-white/70 text-sm">
                <MapPin size={16} className="text-[#F5CD1B] mt-0.5 shrink-0" />
                <span>{CONTACT_INFO.address}</span>
              </li>
            </ul>
            <Link to="/contact" className="mt-6 inline-flex items-center gap-2 text-[#F5CD1B] text-sm font-semibold group">
              Start a project <ArrowUpRight size={16} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </Link>
          </div>
        </div>

        <div className="border-t border-white/5 pt-6 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
          <div>© {new Date().getFullYear()} The Yellow Agency. All rights reserved.</div>
          <div className="flex gap-6">
            <span className="hover:text-white/70 cursor-pointer">Privacy Policy</span>
            <span className="hover:text-white/70 cursor-pointer">Terms & Conditions</span>
            <span>Liverpool · UK Wide · Since 2010</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
